
import BigNumber from "bignumber.js";
import { UIUtilFormat } from "../../ui/util/Format";
import { UIUtilTime } from "../../ui/util/Time";
import { AlumnoEdoCtaUtil } from "../../ui/utilView/AlumnoEdoCta/AlumnoEdoCtaUtil";
import _L, { _HttpMsgV2 } from "../../util/Labels";
import { Entidad } from "../Entidad";
import { IFinanzaAgrupadorCargos } from "../entidad/FinanzaAgrupadorCargos";
import { IFinanzaPagoRecibidoCargo, IFinanzaPagoRecibidoDetalle } from "../entidad/FinanzaIngresoPagoRecibido";
import { _DICC_ALUMNO_FULL } from "../modulo/Alumno";
import { _DICC_ESCUELA } from "../modulo/Escuela";
import { _DICC_AGRUPADORES_FULL } from "../modulo/FinanzaAgrupadorCargos";
import { _SvAlumnoEdoCtaObtenerDetallesPagoEnLineaByFolio, _DICC_ALUMNO_MOVPAGO_FOLIO } from "../modulo/FinanzasEstadoCuenta";
import { CFinanzaDetallePagoEnLineaTipoTarjeta, IFinanzaDetallePagoEnLinea } from "../entidad/FinanzaPagoEnLinea";
import { CFinanzaPagoEnLineaFormaPago } from "../entidad/FinanzasEstadoCuenta";

import CFinanzaCategoriaMovimiento = Entidad.CFinanzaCategoriaMovimiento;
import { UIUtilViewData } from "../../ui/util/ViewData";
import { _APP_CONFIG } from "../../core/config/AppConfig";
import { MEscuela } from "./MEscuela";

export class MFinanzaIngresoPagoRecibido {
    /** Id movimiento detalle */
    readonly Id: number;
    readonly IDFolio: string;
    readonly IdAlumno: number;
    readonly Categoria: CFinanzaCategoriaMovimiento;
    readonly ConceptoCargo: string;
    readonly ValorPago: number;
    readonly IdMetodoPago: number;
    // readonly StrMetodoPagoDetalle: string; // FIXME PENDIENTE Ej: "Tarjeta débito" | "Tarjeta crédito" | "Transferencia bancaria"
    readonly FolioPagoEnLinea: string;
    readonly FechaPago: string;
    readonly FechaAplicacionCargo: string;
    readonly FechaVencimientoCargo: string;
    readonly IdEscuela: number;
    readonly IdAgrupador: number;
    readonly FormaPagoEnLinea: CFinanzaPagoEnLineaFormaPago;

    readonly KinderFiltro: number[];

    /** Se obtiene de la suma: cargoOriginal + recargos + comisiones */
    private __valorCobrarTotal: number;
    private __valorDescuentoTotal: number;
    private __valorCobroFaltanteTotal: number;
    private readonly __movimientoPago: IFinanzaPagoRecibidoDetalle;
    private readonly __cargo: IFinanzaPagoRecibidoCargo;

    private __detallesPagoEnLinea?: IFinanzaDetallePagoEnLinea = null;

    constructor(
        movimientoPagoDetalle: IFinanzaPagoRecibidoDetalle,
        cargoPadre: IFinanzaPagoRecibidoCargo,
        idEscuela: number
    ) {

        const categoriasPago = [CFinanzaCategoriaMovimiento.PagoCompleto, CFinanzaCategoriaMovimiento.PagoParcial];
        const categoriasCargo = [CFinanzaCategoriaMovimiento.Cargo, CFinanzaCategoriaMovimiento.LlegadaAnticipada, CFinanzaCategoriaMovimiento.SalidaTarde];
        if (!categoriasPago.includes(movimientoPagoDetalle.Categoria) || !categoriasCargo.includes(cargoPadre.Categoria)) {
            throw new Error(`MFinanzaIngresoPagoRecibido: Categoria invalida, movimientoPagoDetalle.Categoria: ${movimientoPagoDetalle.Categoria}, cargoPadre.Categoria: ${cargoPadre.Categoria}`);
        }

        this.__movimientoPago = movimientoPagoDetalle;
        this.__cargo = cargoPadre;

        this.Id = movimientoPagoDetalle.Id;
        this.IDFolio = cargoPadre.Id.toString().padStart(6, "0");
        this.IdAlumno = cargoPadre.IdAlumno;
        this.Categoria = cargoPadre.Categoria;
        this.ConceptoCargo = cargoPadre.Concepto;
        this.ValorPago = movimientoPagoDetalle.Valor;
        this.IdMetodoPago = movimientoPagoDetalle.IdMetodoPago;
        this.FolioPagoEnLinea = movimientoPagoDetalle.FolioPago;
        this.IdEscuela = idEscuela;
        this.FechaPago = movimientoPagoDetalle.FechaAplicacion;
        this.FechaAplicacionCargo = cargoPadre.FechaAplicacion;
        this.FechaVencimientoCargo = cargoPadre.FechaVencimiento;
        this.IdAgrupador = cargoPadre.IdAgrupador;
        this.FormaPagoEnLinea = movimientoPagoDetalle.FormaPagoEnLinea;
        this.KinderFiltro = [idEscuela];
        this.calculateTotals();
    }

    // =================================================
    // PRIVATE METHODS
    // =================================================

    private calculateTotals() {
        let totalCobrado = 0;
        let totalDescuento = 0;
        let totalRecargo = 0;
        let totalComision = 0;

        for (const detalle of this.__cargo.Detalles) {
            switch (detalle.Categoria) {
                case CFinanzaCategoriaMovimiento.PagoCompleto:
                case CFinanzaCategoriaMovimiento.PagoParcial:
                    totalCobrado += detalle.Valor;
                    break;
                case CFinanzaCategoriaMovimiento.Descuento:
                    totalDescuento += detalle.Valor;
                    break;
                case CFinanzaCategoriaMovimiento.Morosidad:
                    totalRecargo += detalle.Recargo;
                    break;
                case CFinanzaCategoriaMovimiento.Comision:
                    totalComision += detalle.Valor;
                    break;
            }
        }

        this.__valorDescuentoTotal = totalDescuento;
        this.__valorCobrarTotal = new BigNumber(this.__cargo.Valor).plus(totalRecargo).plus(totalComision).toNumber();
        this.__valorCobroFaltanteTotal = new BigNumber(this.__valorCobrarTotal).minus(new BigNumber(totalDescuento).plus(totalCobrado)).toNumber();
    }

    private _ConsultarDetallesPagoEnLinea(): Promise<IFinanzaDetallePagoEnLinea | null> {
        const ignorarDev = _APP_CONFIG.DEBUG_MODE && [1, 2, 3].includes(this.IdEscuela); // NOTE Escuelas con algun detalle en llaves o cuenta openpay
        if (ignorarDev) {
            return Promise.resolve(null);
        }
        return _SvAlumnoEdoCtaObtenerDetallesPagoEnLineaByFolio(this.FolioPagoEnLinea)
            .then(res => {
                this.__detallesPagoEnLinea = null;
                if (res.Resultado > 0 && res.Datos) {
                    this.__detallesPagoEnLinea = res.Datos;
                } else if (res.Resultado == -1) {
                    this.__detallesPagoEnLinea = {
                        IdFolio: res.Resultado, // -1
                        Description: _HttpMsgV2(res),
                        Card: null
                    };
                }
                return this.__detallesPagoEnLinea;
            });
    }

    // =================================================
    // PUBLIC METHODS
    // =================================================

    /**
    * Consulta y asigna los detalles del pago en línea al movimiento,
    * si el movimiento es un pago en línea con folio asignado.
    *
    * Esta información se puede consultar desde la propiedad: `FolioPagoEnLineaRelacionado`
    *
    * A su ves alimenta las propiedades: `MetodoPagoDetalle`, `MetodoPagoInfoCompleta`
    */
    public _ConsultarYAsignarDetallesPagoEnLinea(): Promise<IFinanzaDetallePagoEnLinea | null> {
        if (!this.FolioPagoEnLinea || this.FormaPagoEnLinea != CFinanzaPagoEnLineaFormaPago.Tarjeta) {
            return Promise.resolve(null);
        }
        if (this.__detallesPagoEnLinea) {
            return Promise.resolve(this.__detallesPagoEnLinea);
        }
        return this._ConsultarDetallesPagoEnLinea();
    }

    // =================================================
    // GETTERS
    // =================================================

    get PadreCargo(): IFinanzaPagoRecibidoCargo {
        return this.__cargo;
    }

    get Agrupador(): IFinanzaAgrupadorCargos | null {
        const idEscuela = this.IdEscuela;
        const idAgrupador = this.IdAgrupador;
        if (!idAgrupador) return null;

        return _DICC_AGRUPADORES_FULL.get(idEscuela)?.get(idAgrupador) || null;
    }

    // PROPERTIES: ALUMNO

    get Alumno(): Entidad.IAlumno | null {
        const idAlumno = this.IdAlumno;
        if (!idAlumno || !_DICC_ALUMNO_FULL.has(idAlumno)) {
            return null;
        }
        return _DICC_ALUMNO_FULL.get(idAlumno);
    }

    get NombreCompletoAlumno(): string {
        const alumno = this.Alumno;
        return alumno ? alumno.NombreCompleto : _L("general.nodisponible");
    }

    get AlumnoEstado(): Entidad.CNinioMovimiento | null {
        const alumno = this.Alumno;
        return alumno ? alumno.IdChildMovimiento : null;
    }

    // PROPERTIES: ESCUELA

    get Escuela(): MEscuela | null {
        const idEscuela = this.IdEscuela;
        if (!idEscuela || !_DICC_ESCUELA.has(idEscuela)) {
            return null;
        }
        return _DICC_ESCUELA.get(idEscuela);
    }

    get StrEscuela(): string {
        const escuela = this.Escuela;
        return escuela ? escuela.Nombre : _L("general.nodisponible");
    }

    // PROPERTIES: VALUES

    get ValorCobrarTotal(): number {
        return this.__valorCobrarTotal;
    }

    get ValorDescuentoTotal(): number {
        return this.__valorDescuentoTotal;
    }

    get ValorCobroFaltanteTotal(): number {
        return this.__valorCobroFaltanteTotal;
    }

    // PROPERTIES: FORMATS

    /** Es la suma del cargoOriginal + recargos + comisiones */
    get ValorCobrarTotalFmt(): string {
        return UIUtilFormat._CurrencyFmt(this.__valorCobrarTotal);
    }

    /** Es la suma de los descuentos aplicados al cargo */
    get ValorDescuentoTotalFmt(): string {
        return UIUtilFormat._CurrencyFmt(this.__valorDescuentoTotal);
    }

    /** Es la diferencia entre el valor a cobrar - (pagos realizados + descuentos) */
    get ValorCobroFaltanteTotalFmt(): string {
        return UIUtilFormat._CurrencyFmt(this.__valorCobroFaltanteTotal);
    }

    get ValorPagoFmt(): string {
        return UIUtilFormat._CurrencyFmt(this.ValorPago);
    }

    get FechaPagoFmt(): string {
        return UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(this.FechaPago, this.IdEscuela, "dd/mm/yyyy h24:mm");
    }

    get FechaAplicacionCargoFmt(): string {
        return UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(this.FechaAplicacionCargo, this.IdEscuela);
    }

    get FechaVencimientoCargoFmt(): string {
        return UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(this.FechaVencimientoCargo, this.IdEscuela);
    }

    get MetodoPagoNombre(): string {
        const idMetodoPago = this.IdMetodoPago;
        return AlumnoEdoCtaUtil._GetNombreMetodoPago(idMetodoPago);
    }

    /** Detalle del método de pago.
     * * Si el movimiento es un pago en línea conciliado, se muestra el tipo de tarjeta ("Débito"/"Crédito").
     * * Si es un pago en linea sin conciliar o diferente de tarjeta, se muestra la forma de pago ("transferencia bancaria", "Tarjeta de crédito/débito", ...).
     */
    get MetodoPagoDetalle(): string | null {
        if (this.__detallesPagoEnLinea?.IdFolio > 0) {
            return {
                [CFinanzaDetallePagoEnLineaTipoTarjeta.Credito]: _L("c_tipotarjeta.credito"),
                [CFinanzaDetallePagoEnLineaTipoTarjeta.Debito]: _L("c_tipotarjeta.debito")
            }[this.__detallesPagoEnLinea.Card.Type] || null;
        }
        else if (this.IdMetodoPago && this.FolioPagoEnLinea) {
            return UIUtilViewData._GetStr_FinanzaPagoEnLineaFormaPago(this.FormaPagoEnLinea);
        }
        if (this.__detallesPagoEnLinea?.IdFolio === -1) {
            return this.__detallesPagoEnLinea.Description || null;
        }
        return null;
    }

    /**
     * Información completa del método de pago, que incluye el nombre del método de pago y su detalle (si aplica), concatenados en un mismo string.
     * @returns "Openpay - Tarjeta de crédito/débito" | "Openpay - Transferencia bancaria" | etc...
     */
    get MetodoPagoInfoCompleta(): string {
        const nombreMetodoPago = this.MetodoPagoNombre;
        const detalleMetodoPago = this.MetodoPagoDetalle;
        if (nombreMetodoPago && detalleMetodoPago) {
            return `${nombreMetodoPago} - ${detalleMetodoPago}`;
        }
        return nombreMetodoPago || detalleMetodoPago || null;
    }
}